//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    $('#js_mini_banner').slick({
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: false,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        speed: 2000,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5,
                }
            }
        ]
    });

    // Verifica se tem pelo menos 8 filhos em desktop
    if (window.innerWidth >= 992) {
        const container = document.querySelector('#categories-home-carrousel');
        const items = Array.from(container.children);

        if (items.length < 8) {
            // Não inicializa o slick se tiver menos de 8 itens em desktop
            console.log('Slick não inicializado - menos de 8 itens em desktop:', items.length);
            return;
        }
    }

    if($('#categories-home-carrousel')) {
        $('#categories-home-carrousel').slick({
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        mobileFirst: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 1000,
        infinite: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 8,
                }
            }
        ]
    });
    }

    $('#js-carrousel-instagram').slick({
        arrows: false,
        dots: false,
        infinite: false,
        autoplay: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 2000,
        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
        ]
    });

    $('#product_list, #product_list-2').slick({
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('.post-carousel').slick({
        slidesToShow  : 2,
        slidesToScroll: 2,
        infinite: false,
        autoplay: false,
        arrows: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            }
        ]
    });

    $('#js-slider-products-banner').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: true,
        mobileFirst: true,
        speed: 1000,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('.banner_communique__list').slick({
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: true,
        mobileFirst: true,
        speed: 1000,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            }
        ]
    });

    $('#product_list, #product_list-2, #js-slider-products-banner').on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    });
})